
import _ from 'lodash';

const namespaced = true;

const state = {
  searchString: ``,
  tags: [],
  isFetchingTags: false,
  isKeepingPreviousState: false,
  currentAdminMaker: {},
};

const mutations = {
  SET_SEARCH_STRING(state, searchString) {
    state.searchString = searchString || ``;
  },
  SET_IS_FETCHING_TAGS(state, isFetchingTags) {
    state.isFetchingTags = Boolean(isFetchingTags);
  },
  SET_TAGS(state, tags) {
    state.tags = tags || [];
  },
  ADD_TAG(state, tag) {
    state.tags.push(tag);
  },
  REMOVE_TAG(state, tag) {
    const tags = _.reject(state.tags, { id: tag.id });
    state.tags = tags;
  },
  SET_KEEPING_PREVIOUS_STATE(state, isKeepingPreviousState) {
    state.isKeepingPreviousState = isKeepingPreviousState;
  },
  SET_CURRENT_ADMIN_MAKER(state, currentAdminMaker) {
    state.currentAdminMaker = currentAdminMaker || {};
  },
};

const actions = {
  async fetchList({ dispatch, rootState, commit }) {
    let list = [];

    try {
      const client = rootState[`model/client`].company;
      list = await dispatch(`model/maker/fetchListForClient`, client.id, { root: true });
    } catch (e) {} // eslint-disable-line

    commit(`model/client/SET_MAKERS`, list, { root: true });
  },
  setList({ commit }, list) {
    commit(`model/client/SET_MAKERS`, list, { root: true });
  },
  async fetchCurrentAdminMaker({ commit, dispatch }, makerId) {
    const maker = await dispatch(`model/maker/fetchOne`, makerId, { root: true });
    commit(`SET_CURRENT_ADMIN_MAKER`, maker);
    return maker;
  },
  async fetchTags({ commit, dispatch, getters }) {
    commit(`SET_IS_FETCHING_TAGS`, true);
    const { clientId, makerId } = getters;
    const tags = await dispatch(`model/maker/fetchTagsForClient`, { makerId, clientId }, { root: true });
    commit(`SET_TAGS`, tags);
    commit(`SET_IS_FETCHING_TAGS`, false);

    return tags;
  },
  async assignTag({ commit, dispatch, getters }, tag) {
    commit(`ADD_TAG`, tag);
    const { clientId, makerId } = getters;
    const tagId = tag.id;
    return dispatch(`model/maker/assignTagToClientMaker`, { clientId, makerId, tagId }, { root: true });
  },
  async unassignTag({ commit, dispatch, getters }, tag) {
    commit(`REMOVE_TAG`, tag);
    const { clientId, makerId } = getters;
    const tagId = tag.id;
    return dispatch(`model/maker/unassignTagToClientMaker`, { clientId, makerId, tagId }, { root: true });
  },
};

const getters = {
  list(state, getters, rootState) {
    return rootState[`model/client`].makers;
  },
  clientId(state, getters, rootState) {
    const { id: clientId } = rootState[`model/client`].company;

    return clientId;
  },
  makerId(state) {
    const { id: makerId } = state.currentAdminMaker;

    return makerId;
  },
};

export default {
  namespaced, state, mutations, actions, getters,
};
